import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Grid from '@material-ui/core/Grid';
import { Box, Paper, Typography } from '@material-ui/core';
import clsx from 'clsx';
import type { IFilter, IWorkViewPrimaryGroup, IWorkViewPrimaryGroupData } from '../WorkViewInterfaces';
import WorkViewSet from '../SetView';

const useStyles = makeStyles(() => createStyles({
  primaryGroup: {
    minWidth: '202px',
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    padding: '40px 0 49px 0',
    borderRight: '1px solid #F2F2F2',
  },
  primaryGroupName: {
    font: 'Roboto',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '18.75px',
    color: '#2F2F2F',
    padding: '2px 0',
  },
  countStyle: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '14.06px',
  },
  mainDiv: {
    display: 'flex',
  },
  listItem: {
    padding: '2px 0',
  },
  fiveColumnStyle: {
    flexBasis: '20%',
    maxWidth: '20%',
  },
}));
interface ColumnerLayoutProps {
  primaryGroups: IWorkViewPrimaryGroup[];
  columnerValue: number;
  primaryGroupData: IWorkViewPrimaryGroupData[];
  filter: IFilter;
}

const ColumnerLayout: React.FC<ColumnerLayoutProps> = ({
  primaryGroups, columnerValue, primaryGroupData, filter,
}) => {
  const classes = useStyles();

  // eslint-disable-next-line no-nested-ternary
  const colSpan = columnerValue === 1 ? 12 : (columnerValue === 2 ? 6 : (columnerValue === 3 ? 4 : (columnerValue === 4 ? 3 : 2)));

  return (
    <Paper>
      <div className={classes.mainDiv}>
        <Grid xs={12}>
          <Grid
            container
            spacing={7}
            style={{
              margin: 0, display: 'flex', width: '100%',
            }}
          >
            {primaryGroups.map((primaryGroup, index) => (
              <Grid
                item
                xs={colSpan}
                className={clsx(classes.primaryGroup, columnerValue === 5 ? classes.fiveColumnStyle : null)}
                style={{ borderBottom: index !== primaryGroups.length - 1 ? '1px solid #F2F2F2' : 'none' }}
              >
                <Box style={{ padding: '0 44px' }}>
                  <List style={{ padding: 0 }}>
                    <ListItem className={classes.listItem}>
                      <Typography className={classes.primaryGroupName}>
                        {primaryGroup.name}
                      </Typography>
                    </ListItem>
                    <ListItem className={classes.listItem}>
                      <Typography className={classes.countStyle}>
                        {`${primaryGroupData[index].totalItems.toString()} Total Items`}
                      </Typography>
                    </ListItem>
                    <br />
                    {primaryGroup.sets.map((set, setIndex) => (
                      <WorkViewSet
                        setName={set.name}
                        isColored={set.color}
                        color={filter.color}
                        displayStyle={set.displayStyle}
                        setData={primaryGroupData[index].sets[setIndex].totalItems}
                      />
                    ))}
                  </List>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
};

export default ColumnerLayout;
